import React from 'react'
import { Layout } from 'antd'

const { Footer: AntFooter } = Layout

const Footer: React.FC = () => {
  return (
    <AntFooter className="bg-white border-t border-gray-200 py-4 mt-auto">
      <div className="container mx-auto px-6 flex justify-between items-center text-sm text-gray-600">
        <div className="flex items-center space-x-4">
          <span className="font-medium text-blue-600">OMRON</span>
          <span>OMRON HEALTHCARE Co., Ltd. © All Rights Reserved.</span>
        </div>
        <div className="text-blue-600 font-medium">
          All for Healthcare
        </div>
      </div>
    </AntFooter>
  )
}

export default Footer 